import { Directive, Input, TemplateRef } from '@angular/core';

export type DocDrawerTemplateType = 'header' | 'content' | 'footer';

@Directive({
  selector: '[docDrawerTemplate]',
  standalone: true,
})
export class DocDrawerTemplateDirective {
  @Input('docDrawerTemplate') type: DocDrawerTemplateType = 'content';

  constructor(public readonly template: TemplateRef<unknown>) {}
}
